<template>
  <div id="maintenance">
    <h3 className="title">Under Maintenance!</h3>
    <p className="description">
      We will be undergoing a system maintenance on 22nd August 2026 from 3:30
      AM (UTC) to 22nd August 2026 1:00 PM (UTC) hours. Avoid using the
      application during the maintenance window.
      <!-- The application is temporarily unavailable due to an ongoing platform
      issue. At this time, there is no estimated time for resolution. We
      sincerely apologize for the inconvenience and appreciate your patience. -->
    </p>
    <svg
      viewBox="0 0 378 239"
      width="100%"
      height="100%"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0)">
        <path
          d="M374.217 170.556C378.382 157.454 379.104 143.501 376.315 130.039C371.772 109.037 357.142 83.6092 314.926 72.6403C235.004 51.8657 207.244 -8.89256 132.485 10.4688C132.485 10.4688 92.3559 17.7632 73.3674 84.1636C54.3788 150.564 -20.0213 151.695 5.59757 209.507C9.78223 218.965 21.0537 229.27 37.2489 239.011L340.501 237.989C361.392 212.79 367.913 190.993 374.217 170.556Z"
          fill="#4DB5AB" />
        <path
          d="M302.677 123.082H291.307V110.624C291.304 107.65 290.297 104.765 288.448 102.436C286.599 100.108 284.018 98.4725 281.123 97.7959V82.3481H276.938V97.5024C273.67 97.8082 270.633 99.3226 268.422 101.749C266.21 104.176 264.984 107.34 264.982 110.624V123.43H253.634V137.714H252.874V164.24L232.309 164.098V132.388H208.766V155.63H192.201V178.198H172.213V237.989H336.132V162.598H302.655L302.677 123.082Z"
          fill="#00786B" />
        <path
          d="M67.9546 155.913V126.202H79.0847V110.309H83.2694V126.202H93.53V155.913H105.041V173.709H123.388V113.081H161.68V237.956H136.724H125.975H98.9211H86.4324H53.792V155.913H67.9546Z"
          fill="#00786B" />
        <path
          d="M277.166 237.663L102.627 237.793C99.4561 237.793 96.415 236.534 94.1728 234.291C91.9306 232.048 90.6709 229.007 90.6709 225.835L289.143 225.683C289.146 227.257 288.838 228.816 288.237 230.271C287.637 231.726 286.754 233.048 285.642 234.161C284.529 235.274 283.207 236.156 281.753 236.757C280.298 237.358 278.739 237.666 277.166 237.663Z"
          fill="#0073AB" />
        <path
          d="M277.166 233.543L102.617 233.673C100.166 233.676 97.7735 232.926 95.7633 231.524C93.7531 230.122 92.2221 228.136 91.3778 225.835H90.6387C90.6387 229.007 91.8983 232.048 94.1406 234.291C96.3828 236.533 99.4239 237.793 102.595 237.793L277.133 237.663C280.304 237.663 283.345 236.403 285.588 234.16C287.83 231.918 289.09 228.876 289.09 225.705H288.35C287.509 227.997 285.987 229.977 283.987 231.378C281.988 232.779 279.607 233.535 277.166 233.543Z"
          fill="#42B0D5" />
        <path
          d="M201.157 229.76H178.614C177.552 229.76 176.534 229.338 175.782 228.588C175.03 227.839 174.606 226.821 174.604 225.759V225.759H205.168C205.162 226.82 204.737 227.836 203.986 228.585C203.235 229.335 202.218 229.757 201.157 229.76V229.76Z"
          fill="#27429C" />
        <path
          d="M278.915 225.683L100.855 225.824L100.779 118.342C100.776 116.876 101.063 115.423 101.622 114.067C102.181 112.711 103.002 111.479 104.038 110.441C105.074 109.403 106.304 108.58 107.659 108.018C109.013 107.456 110.465 107.167 111.931 107.167L267.655 107.047C269.121 107.046 270.573 107.333 271.928 107.893C273.282 108.453 274.514 109.274 275.551 110.309C276.589 111.345 277.412 112.575 277.975 113.929C278.537 115.283 278.827 116.735 278.829 118.201L278.915 225.683Z"
          fill="#42B0D5" />
        <path
          d="M269.601 116.385H110.095V216.464H269.601V116.385Z"
          fill="#044F74" />
        <path
          d="M269.633 206.898H110.127V216.464H269.633V206.898Z"
          fill="#00233D" />
        <path
          d="M269.557 116.385H110.051V121.136H269.557V116.385Z"
          fill="#00233D" />
        <path
          opacity="0.16"
          d="M163.245 116.407L110.095 169.654L110.127 216.529H110.247L210.233 116.375L163.245 116.407Z"
          fill="#42B0D5" />
        <path
          opacity="0.16"
          d="M130.725 216.519L154.278 216.497L254.265 116.331L230.711 116.353L130.725 216.519Z"
          fill="#42B0D5" />
        <path
          opacity="0.16"
          d="M250.874 216.421L269.623 197.636L269.59 162.109L213.32 216.443L250.874 216.421Z"
          fill="#42B0D5" />
        <path
          d="M278.915 159.13H100.779V178.796H278.915V159.13Z"
          fill="#D6E001" />
        <path d="M123.056 179H108L120.954 159H136L123.056 179Z" fill="white" />
        <path d="M155.583 179H140L153.417 159H169L155.583 179Z" fill="white" />
        <path d="M188.583 179H173L186.417 159H202L188.583 179Z" fill="white" />
        <path d="M221.046 179H206L218.954 159H234L221.046 179Z" fill="white" />
        <path d="M253.583 179H238L251.417 159H267L253.583 179Z" fill="white" />
        <path
          d="M86.4757 125.18L82.9867 125.311L80.9542 124.669C80.4984 124.516 80.0047 124.518 79.5504 124.676C79.0961 124.833 78.7068 125.137 78.4434 125.539L78.1934 125.919L88.367 131.54L90.2908 127.322L86.4757 125.18Z"
          fill="#14103D" />
        <path
          d="M88.3778 131.637L78.1172 125.963L78.4759 125.31C78.4928 125.28 78.5156 125.254 78.5429 125.233C78.5701 125.211 78.6014 125.196 78.6347 125.186C78.6681 125.177 78.703 125.175 78.7373 125.179C78.7716 125.184 78.8047 125.195 78.8346 125.213L88.856 130.746L88.3778 131.637"
          fill="#14103D" />
        <path
          d="M90.345 127.322L93.0297 122.658L90.345 117.864L86.4756 125.169L90.345 127.322Z"
          fill="#F8BAA3" />
        <path
          d="M111.41 100.546C111.41 100.546 96.8991 96.3826 95.5078 100.296C94.1165 104.21 85.6494 121.549 85.6494 121.549L91.9644 124.81L101.432 108.352L114.181 107.265L111.41 100.546Z"
          fill="#14103D" />
        <path
          d="M99.6171 130.463L96.8128 132.268L94.7151 132.692C94.2426 132.78 93.8126 133.021 93.492 133.379C93.1715 133.737 92.9785 134.191 92.9434 134.67V135.127H104.573L104.247 130.474L99.6171 130.463Z"
          fill="#14103D" />
        <path
          d="M104.551 135.192H92.8232V134.453C92.8232 134.419 92.83 134.385 92.8431 134.353C92.8562 134.322 92.8754 134.293 92.8997 134.269C92.9239 134.244 92.9526 134.225 92.9843 134.212C93.0159 134.199 93.0499 134.192 93.0841 134.192H104.54V135.203"
          fill="#14103D" />
        <path
          d="M104.182 130.463L104.552 122.658L99.9215 122.136L99.6172 130.453L104.182 130.463Z"
          fill="#F8BAA3" />
        <path
          d="M113.366 99.8833L99.6927 100.503C99.6927 100.503 97.7254 100.612 97.8558 105.21C97.9863 109.809 97.9754 128.344 97.9754 128.344L104.551 128.572L105.801 109.167L119.497 108.993C120.915 108.993 122.303 108.582 123.493 107.811C124.683 107.039 125.624 105.94 126.203 104.645C126.681 103.597 126.814 102.425 126.583 101.297L113.366 99.8833Z"
          fill="#231C61" />
        <path
          d="M100.389 97.1219C100.389 98.4156 99.5193 98.6113 98.215 98.6113C96.9107 98.6113 95.6934 98.4265 95.6934 97.1328C95.6934 96.5101 95.9407 95.9128 96.381 95.4724C96.8213 95.0321 97.4185 94.7847 98.0411 94.7847C98.6638 94.7847 99.2609 95.0321 99.7012 95.4724C100.142 95.9128 100.389 96.5101 100.389 97.1328V97.1219Z"
          fill="#E1AD9D" />
        <path
          d="M102.04 98.4483H99.3227C98.9824 98.4455 98.6567 98.3098 98.415 98.0701C98.1734 97.8304 98.035 97.5058 98.0293 97.1655V97.1655C98.0321 96.8233 98.1693 96.4959 98.4113 96.2539C98.6532 96.0119 98.9806 95.8747 99.3227 95.8718H102.04C102.381 95.8718 102.709 96.0066 102.951 96.2469C103.193 96.4871 103.331 96.8134 103.333 97.1546C103.331 97.4968 103.193 97.8242 102.952 98.0662C102.71 98.3082 102.382 98.4454 102.04 98.4483V98.4483Z"
          fill="#E1AD9D" />
        <path
          d="M101.942 98.7199L101.029 94.2737L112.192 93.0561L114.431 80.0109C114.659 78.8259 116.366 77.3583 117.561 77.5866L117.214 77.4888C117.83 77.6341 118.375 77.9937 118.751 78.5033C119.127 79.013 119.311 79.6397 119.268 80.2718L117.094 95.8826C117.017 96.2959 116.823 96.6781 116.533 96.9829C116.244 97.2878 115.872 97.5022 115.464 97.6002L101.942 98.7199Z"
          fill="#C8C6F2" />
        <path
          d="M124.236 77.8694C124.466 77.8917 124.692 77.9429 124.91 78.0216H125.019C125.947 78.4336 126.742 79.0945 127.318 79.9311C127.893 80.7677 128.226 81.7473 128.279 82.7614L126.54 101.242C114.965 101.144 113.323 99.8181 113.323 99.8181L114.247 80.8807C114.388 79.0978 115.204 77.4128 117.236 77.2498L124.236 77.8694Z"
          fill="#D8D7FD" />
        <path
          d="M111.497 98.5787C111.595 99.8723 110.725 100.122 109.432 100.209C108.138 100.296 106.899 100.209 106.812 98.8939C106.778 98.2766 106.988 97.6704 107.397 97.207C107.806 96.7436 108.382 96.4604 108.999 96.4189C109.616 96.3774 110.224 96.5809 110.692 96.9853C111.159 97.3896 111.449 97.9622 111.497 98.5787V98.5787Z"
          fill="#F8BAA3" />
        <path
          d="M113.236 99.7853L110.529 99.9701C110.188 99.994 109.851 99.8816 109.592 99.6574C109.333 99.4333 109.174 99.1157 109.149 98.7742V98.7742C109.128 98.4328 109.243 98.0969 109.469 97.8402C109.695 97.5835 110.014 97.4269 110.355 97.4045L113.062 97.2197C113.23 97.2079 113.4 97.2295 113.56 97.2832C113.72 97.337 113.868 97.4219 113.995 97.533C114.122 97.6441 114.226 97.7793 114.301 97.9307C114.376 98.0822 114.42 98.2469 114.431 98.4155V98.4155C114.443 98.584 114.422 98.7532 114.368 98.9134C114.314 99.0736 114.229 99.2216 114.118 99.3489C114.007 99.4761 113.872 99.5802 113.72 99.6551C113.569 99.73 113.404 99.7742 113.236 99.7853V99.7853Z"
          fill="#F8BAA3" />
        <path
          d="M113.117 100.068L111.921 95.7195L124.084 93.7627L123.388 82.446C123.489 81.8009 123.809 81.2102 124.294 80.7728C124.779 80.3354 125.399 80.0779 126.051 80.0435V80.0435C126.677 80.1492 127.244 80.4741 127.653 80.9601C128.061 81.446 128.283 82.0613 128.279 82.696L129.16 96.2522C129.114 96.6663 128.95 97.0585 128.688 97.3823C128.426 97.7061 128.077 97.9477 127.681 98.0785L113.117 100.068Z"
          fill="#D8D7FD" />
        <path
          d="M92.0952 85.0333L105.377 86.2944C105.589 86.313 105.789 86.4044 105.941 86.5529C106.094 86.7015 106.19 86.8982 106.214 87.1097L107.606 99.0679C107.63 99.2094 107.621 99.3546 107.58 99.4921C107.539 99.6297 107.466 99.7559 107.369 99.861C107.271 99.9661 107.15 100.047 107.016 100.098C106.882 100.149 106.738 100.169 106.595 100.155L93.0951 98.8831C92.8805 98.8616 92.6799 98.7665 92.5274 98.6139C92.3748 98.4613 92.2797 98.2607 92.2582 98.046L91.0844 86.0878C91.0658 85.9488 91.0788 85.8073 91.1224 85.6739C91.166 85.5406 91.2391 85.4187 91.3362 85.3174C91.4333 85.2161 91.5519 85.138 91.6833 85.0888C91.8147 85.0397 91.9555 85.0207 92.0952 85.0333Z"
          fill="#091218" />
        <path
          d="M91.378 84.968L104.649 86.2182C104.862 86.2348 105.062 86.3255 105.215 86.4744C105.368 86.6234 105.464 86.8212 105.486 87.0335L106.878 98.9917C106.904 99.1336 106.897 99.2797 106.856 99.4182C106.816 99.5568 106.744 99.6841 106.646 99.7897C106.547 99.8954 106.426 99.9766 106.291 100.027C106.155 100.077 106.01 100.095 105.867 100.079L92.378 98.8069C92.1625 98.7874 91.9608 98.693 91.8079 98.54C91.6549 98.387 91.5605 98.1852 91.541 97.9698L90.3671 86.0116C90.3504 85.8734 90.3647 85.7332 90.4091 85.6012C90.4535 85.4692 90.5269 85.3488 90.6237 85.2488C90.7206 85.1487 90.8386 85.0716 90.9691 85.0231C91.0996 84.9745 91.2393 84.9557 91.378 84.968V84.968Z"
          fill="#1B2934" />
        <path
          d="M107.236 99.1658L116.301 100.025C116.367 100.03 116.431 100.048 116.489 100.079C116.548 100.109 116.6 100.151 116.642 100.201C116.685 100.252 116.717 100.31 116.737 100.373C116.756 100.436 116.763 100.502 116.757 100.568C116.744 100.7 116.679 100.821 116.578 100.906C116.477 100.991 116.346 101.034 116.214 101.025L106.595 100.155L107.236 99.1658Z"
          fill="#091218" />
        <path
          d="M98.9865 92.2192C98.9613 92.5071 98.8511 92.7809 98.6699 93.0059C98.4887 93.231 98.2446 93.397 97.9688 93.483C97.693 93.569 97.3978 93.5709 97.1209 93.4886C96.8439 93.4064 96.5977 93.2436 96.4135 93.021C96.2293 92.7984 96.1155 92.526 96.0865 92.2385C96.0575 91.951 96.1146 91.6614 96.2506 91.4065C96.3866 91.1515 96.5953 90.9428 96.8502 90.8068C97.1052 90.6709 97.3948 90.6138 97.6822 90.6429C98.0631 90.6814 98.4135 90.8685 98.6576 91.1635C98.9017 91.4585 99.0199 91.8377 98.9865 92.2192Z"
          fill="white" />
        <path
          d="M123.007 85.0334L123.301 93.5346L111.953 95.6979L121.953 92.5671L123.007 85.0334Z"
          fill="#C8C6F2" />
        <path
          d="M116.985 76.7388L117.735 78.7825C117.873 79.141 118.109 79.4531 118.417 79.6822C118.725 79.9112 119.092 80.0479 119.474 80.0762V80.0762C119.815 80.1004 120.156 80.0365 120.465 79.8906C120.774 79.7447 121.04 79.5218 121.237 79.2433C121.435 78.9648 121.558 78.6401 121.593 78.3005C121.629 77.9608 121.577 77.6177 121.442 77.3041L120.116 74.1624L116.985 76.7388Z"
          fill="#F8BAA3" />
        <path
          d="M117.66 78.5106C117.66 78.5106 121.399 77.804 120.844 74.5318C120.29 71.2596 116.779 73.8143 116.779 73.8143L117.127 77.0757L117.66 78.5106Z"
          fill="#DDA18A" />
        <path
          d="M111.888 68.7267C111.395 69.7783 111.224 70.9527 111.398 72.1013C111.573 73.2498 112.084 74.3209 112.867 75.1788C113.65 76.0368 114.67 76.643 115.798 76.9208C116.926 77.1987 118.11 77.1356 119.202 76.7395C120.294 76.3435 121.244 75.6324 121.932 74.6961C122.619 73.7599 123.014 72.6406 123.065 71.4801C123.116 70.3195 122.822 69.1698 122.22 68.1765C121.618 67.1833 120.734 66.391 119.681 65.9002C118.272 65.2464 116.662 65.1767 115.202 65.7063C113.742 66.2359 112.551 67.3217 111.888 68.7267V68.7267Z"
          fill="#F8BAA3" />
        <path
          d="M119.377 72.4121C119.377 72.4121 118.453 77.1084 121.91 77.2171C125.366 77.3258 123.486 68.4006 123.486 68.4006L118.051 62.8999L109.682 64.9654L110.519 70.4009C110.519 70.4009 111.845 71.1076 119.029 69.9226L119.377 72.4121Z"
          fill="#231C61" />
        <path
          d="M115.964 68.7375L118.714 72.749L121.083 70.1399L115.964 68.7375Z"
          fill="#231C61" />
        <path
          d="M118.454 71.3251C118.314 71.6219 118.266 71.9535 118.316 72.2776C118.366 72.6018 118.511 72.9038 118.732 73.1453C118.954 73.3868 119.243 73.5568 119.562 73.6337C119.88 73.7105 120.215 73.6908 120.522 73.577C120.83 73.4632 121.096 73.2605 121.288 72.9946C121.48 72.7288 121.589 72.4118 121.6 72.0841C121.611 71.7563 121.525 71.4327 121.352 71.1542C121.178 70.8758 120.926 70.6552 120.627 70.5206C120.231 70.3482 119.784 70.3357 119.379 70.4856C118.974 70.6355 118.642 70.9363 118.454 71.3251V71.3251Z"
          fill="#F8BAA3" />
        <path
          d="M110.746 70.2814C110.746 70.2814 109.486 65.6612 112.475 62.7913C113.063 62.229 113.76 61.7922 114.523 61.5074C115.285 61.2225 116.098 61.0956 116.911 61.1342C117.724 61.1728 118.521 61.3762 119.253 61.7321C119.985 62.088 120.637 62.5888 121.17 63.2044C122.47 64.881 123.153 66.9539 123.105 69.0748L110.746 70.2814Z"
          fill="#F5D100" />
        <path
          d="M111.388 70.2052V67.3135C111.382 66.9615 111.514 66.6211 111.756 66.3651C111.997 66.1092 112.33 65.9579 112.681 65.9438V65.9438C113.028 65.9281 113.367 66.0454 113.63 66.2718C113.892 66.4981 114.059 66.8164 114.094 67.1613L114.377 70.0422"
          stroke="#F1AB00"
          stroke-width="0.28"
          stroke-miterlimit="10" />
        <path
          d="M123.127 69.0747L109.671 70.3684"
          stroke="white"
          stroke-width="1.12"
          stroke-linecap="round"
          stroke-linejoin="round" />
        <path
          d="M245.645 225.02L248.656 227.944L245.221 229.792L242.275 226.911L245.645 225.02Z"
          fill="#F8BAA3" />
        <path
          d="M224.406 203.191L226.417 212.116C226.842 213.942 227.621 215.667 228.71 217.193L241.982 229.151L247.232 224.868L235.906 212.909L231.754 197.005L224.406 203.191Z"
          fill="#14103D" />
        <path
          d="M245.113 229.716L244.026 233.184L242.787 234.912C242.504 235.298 242.357 235.765 242.367 236.242C242.376 236.72 242.543 237.181 242.841 237.554L243.113 237.913L251.58 230.02L248.2 226.857L245.113 229.716Z"
          fill="#14103D" />
        <path
          d="M251.677 230.042L243.145 238L242.46 237.261L250.992 229.314L251.677 230.042Z"
          fill="#14103D" />
        <path
          d="M216.624 230.455L215.494 234.228L211.613 233.184L212.744 229.477L216.624 230.455Z"
          fill="#F8BAA3" />
        <path
          d="M221.809 193.244L210.939 230.042L217.809 231.749L223.983 213.312L231.515 201.245C231.909 200.704 232.272 200.141 232.602 199.56C233.183 198.482 233.479 197.273 233.461 196.048V193.657L221.809 193.244Z"
          fill="#231C61" />
        <path
          d="M211.831 232.88L208.397 234.152L206.223 234.228C205.741 234.236 205.276 234.404 204.901 234.705C204.525 235.006 204.26 235.423 204.147 235.891L204.038 236.337L215.538 238.228L215.983 233.575L211.831 232.88Z"
          fill="#14103D" />
        <path
          d="M215.602 238.25L204.016 236.348L204.179 235.347L215.765 237.261L215.602 238.25Z"
          fill="#14103D" />
        <path
          d="M206.646 155.858L202.244 162.729L204.353 164.24L208.907 156.978L206.646 155.858Z"
          fill="#334FBE" />
        <path
          d="M200.929 144.487C200.929 144.487 202.961 152.999 213.265 156.347C213.41 156.393 213.54 156.479 213.64 156.594C213.74 156.709 213.806 156.849 213.83 157C214.025 157.785 213.907 158.615 213.501 159.314C213.096 160.014 212.434 160.529 211.657 160.75C211.548 160.776 211.435 160.78 211.325 160.762C211.215 160.743 211.109 160.702 211.015 160.641C209.439 159.663 201.689 155.13 194.168 156.434L200.929 144.487Z"
          fill="#4265D1" />
        <path
          d="M200.929 144.487C200.929 144.487 199.038 152.977 194.19 156.445C194.19 156.434 194.875 148.999 200.929 144.487Z"
          fill="#334FBE" />
        <path
          d="M200.81 162.283C200.709 163.111 200.908 163.948 201.37 164.642C201.833 165.336 202.529 165.841 203.332 166.066C204.083 166.22 204.864 166.07 205.504 165.648C206.144 165.226 206.59 164.567 206.745 163.816C206.845 162.986 206.645 162.149 206.18 161.454C205.715 160.76 205.017 160.256 204.212 160.033C203.841 159.957 203.458 159.954 203.086 160.026C202.714 160.098 202.36 160.243 202.044 160.452C201.728 160.661 201.456 160.93 201.245 161.244C201.033 161.559 200.885 161.912 200.81 162.283V162.283Z"
          fill="#F8BAA3" />
        <path
          d="M209.081 166.871L206.027 163.675L204.038 166.131L209.081 169.828"
          fill="#F8BAA3" />
        <path
          d="M208.592 163.925L205.331 168.719L214.2 176.785C214.737 176.936 215.296 176.992 215.852 176.948L227.493 175.437C227.93 175.417 228.358 175.312 228.754 175.126C229.149 174.941 229.504 174.679 229.798 174.355C230.092 174.032 230.319 173.654 230.467 173.243C230.614 172.831 230.678 172.395 230.656 171.958V171.958C230.569 170.121 230.928 167.469 229.091 167.61L215.57 170.382L208.592 163.925Z"
          fill="#C8C6F2" />
        <path
          d="M234.689 174.926C234.849 173.678 234.652 172.41 234.121 171.269C233.59 170.128 232.747 169.161 231.689 168.479C230.943 167.889 230.021 167.564 229.07 167.555C227.769 167.666 226.531 168.16 225.512 168.975C224.492 169.789 223.737 170.888 223.342 172.132C221.603 177.459 221.103 193.211 221.103 193.211L233.58 193.646L234.689 174.926Z"
          fill="#D8D7FD" />
        <path
          d="M230.091 175.317L233.841 189.102L234.602 177.405L230.091 175.317Z"
          fill="#C8C6F2" />
        <path
          d="M245.374 202.528C245.947 201.918 246.282 201.123 246.318 200.286C246.354 199.45 246.088 198.629 245.569 197.973C245.053 197.41 244.335 197.074 243.572 197.037C242.809 197.001 242.062 197.266 241.493 197.777C240.92 198.387 240.585 199.182 240.549 200.018C240.513 200.854 240.779 201.675 241.298 202.332C241.815 202.895 242.533 203.231 243.296 203.267C244.059 203.304 244.805 203.038 245.374 202.528V202.528Z"
          fill="#F8BAA3" />
        <path
          d="M239.722 192.7L241.993 198.31L245.048 197.505L243.156 191.548"
          fill="#F8BAA3" />
        <path
          d="M239.863 197.005L246.102 195.625L241.874 181.133C241.712 180.597 241.459 180.093 241.124 179.644L233.341 169.969C232.254 168.458 230.526 168.73 228.994 169.773C228.272 170.28 227.781 171.051 227.626 171.918C227.471 172.786 227.666 173.68 228.168 174.404L235.656 183.416L239.863 197.005Z"
          fill="#D8D7FD" />
        <path
          d="M226.156 165.664L226.395 167.838C226.439 168.223 226.592 168.588 226.837 168.889C227.081 169.189 227.407 169.413 227.776 169.534V169.534C228.104 169.64 228.453 169.66 228.791 169.593C229.129 169.526 229.444 169.373 229.706 169.15C229.969 168.927 230.17 168.64 230.29 168.317C230.411 167.994 230.447 167.646 230.395 167.305L229.863 163.914L226.156 165.664Z"
          fill="#F8BAA3" />
        <path
          d="M226.363 167.653C226.363 167.653 230.211 167.523 230.483 164.186C230.754 160.848 226.668 162.827 226.668 162.827L226.189 166.088L226.363 167.653Z"
          fill="#DDA18A" />
        <path
          d="M223.146 156.576C222.399 157.483 221.939 158.591 221.823 159.76C221.707 160.93 221.94 162.107 222.494 163.143C223.047 164.179 223.896 165.028 224.932 165.582C225.968 166.136 227.145 166.369 228.314 166.253C229.483 166.138 230.591 165.677 231.498 164.931C232.405 164.185 233.071 163.186 233.41 162.061C233.75 160.936 233.747 159.736 233.404 158.613C233.061 157.489 232.392 156.493 231.482 155.749C230.266 154.756 228.706 154.285 227.143 154.44C225.581 154.595 224.143 155.363 223.146 156.576Z"
          fill="#F8BAA3" />
        <path
          d="M229.569 162.011C229.569 162.011 227.493 166.36 230.852 167.349C234.211 168.338 234.591 159.098 234.591 159.098L230.602 152.347L221.907 152.282L221.374 157.793C221.374 157.793 222.461 158.815 229.841 159.446L229.569 162.011Z"
          fill="#231C61" />
        <path
          d="M227.146 157.554L228.841 162.185L231.808 160.207L227.146 157.554Z"
          fill="#231C61" />
        <path
          d="M228.939 160.718C228.73 160.974 228.602 161.287 228.571 161.617C228.54 161.946 228.607 162.277 228.764 162.569C228.921 162.86 229.161 163.098 229.453 163.253C229.745 163.408 230.077 163.473 230.406 163.44C230.735 163.406 231.047 163.276 231.302 163.065C231.558 162.855 231.745 162.573 231.84 162.257C231.936 161.94 231.935 161.602 231.838 161.285C231.742 160.969 231.553 160.688 231.297 160.478C231.127 160.339 230.931 160.234 230.72 160.171C230.509 160.107 230.288 160.086 230.069 160.108C229.849 160.131 229.637 160.196 229.443 160.3C229.249 160.405 229.078 160.547 228.939 160.718Z"
          fill="#F8BAA3" />
        <path
          d="M221.613 158.282C221.613 158.282 221.32 153.445 224.874 151.238C225.572 150.801 226.351 150.511 227.164 150.384C227.977 150.257 228.808 150.296 229.605 150.499C230.403 150.703 231.151 151.066 231.804 151.566C232.458 152.067 233.003 152.695 233.406 153.412C234.343 155.344 234.585 157.541 234.091 159.63L221.613 158.282Z"
          fill="#F5D100" />
        <path
          d="M222.255 158.337L222.82 155.478C222.894 155.129 223.098 154.822 223.391 154.62C223.685 154.418 224.044 154.336 224.396 154.391V154.391C224.743 154.45 225.054 154.639 225.267 154.92C225.479 155.201 225.576 155.552 225.537 155.902L225.222 158.804"
          stroke="#F1AB00"
          stroke-width="0.28"
          stroke-miterlimit="10" />
        <path
          d="M234.113 159.663L220.526 158.141"
          stroke="white"
          stroke-width="1.13"
          stroke-linecap="round"
          stroke-linejoin="round" />
        <path
          d="M317.045 194.842L302.98 208.702"
          stroke="#7B9D00"
          stroke-width="2.65"
          stroke-miterlimit="10" />
        <path
          d="M317.045 180.025L302.98 193.885"
          stroke="#7B9D00"
          stroke-width="2.65"
          stroke-miterlimit="10" />
        <path
          d="M317.045 165.207L302.98 179.079"
          stroke="#7B9D00"
          stroke-width="2.65"
          stroke-miterlimit="10" />
        <path
          d="M317.045 150.401L302.98 164.261"
          stroke="#7B9D00"
          stroke-width="2.65"
          stroke-miterlimit="10" />
        <path
          d="M317.045 135.584L302.98 149.444"
          stroke="#7B9D00"
          stroke-width="2.65"
          stroke-miterlimit="10" />
        <path
          d="M317.045 120.777L302.98 134.638"
          stroke="#7B9D00"
          stroke-width="2.65"
          stroke-miterlimit="10" />
        <path
          d="M317.045 105.96L302.98 119.821"
          stroke="#7B9D00"
          stroke-width="2.65"
          stroke-miterlimit="10" />
        <path
          d="M317.045 91.1538L302.98 105.014"
          stroke="#7B9D00"
          stroke-width="2.65"
          stroke-miterlimit="10" />
        <path
          d="M317.045 76.3364L302.98 90.197"
          stroke="#7B9D00"
          stroke-width="2.65"
          stroke-miterlimit="10" />
        <path
          d="M317.045 61.5193L302.98 75.3799"
          stroke="#7B9D00"
          stroke-width="2.65"
          stroke-miterlimit="10" />
        <path
          d="M317.045 46.7129L302.98 60.5735"
          stroke="#7B9D00"
          stroke-width="2.65"
          stroke-miterlimit="10" />
        <path
          d="M302.98 193.885H317.045"
          stroke="#7B9D00"
          stroke-width="2.65"
          stroke-miterlimit="10" />
        <path
          d="M302.98 179.079H317.045"
          stroke="#7B9D00"
          stroke-width="2.65"
          stroke-miterlimit="10" />
        <path
          d="M302.98 164.261H317.045"
          stroke="#7B9D00"
          stroke-width="2.65"
          stroke-miterlimit="10" />
        <path
          d="M302.98 149.444H317.045"
          stroke="#7B9D00"
          stroke-width="2.65"
          stroke-miterlimit="10" />
        <path
          d="M302.98 134.638H317.045"
          stroke="#7B9D00"
          stroke-width="2.65"
          stroke-miterlimit="10" />
        <path
          d="M302.98 119.821H317.045"
          stroke="#7B9D00"
          stroke-width="2.65"
          stroke-miterlimit="10" />
        <path
          d="M302.98 105.014H317.045"
          stroke="#7B9D00"
          stroke-width="2.65"
          stroke-miterlimit="10" />
        <path
          d="M302.98 90.197H317.045"
          stroke="#7B9D00"
          stroke-width="2.65"
          stroke-miterlimit="10" />
        <path
          d="M302.98 75.3799H317.045"
          stroke="#7B9D00"
          stroke-width="2.65"
          stroke-miterlimit="10" />
        <path
          d="M302.98 60.5735H317.045"
          stroke="#7B9D00"
          stroke-width="2.65"
          stroke-miterlimit="10" />
        <path
          d="M302.98 212.714V49.0828"
          stroke="#A3BF00"
          stroke-width="2.65"
          stroke-miterlimit="10" />
        <path
          d="M317.045 212.714V49.0828"
          stroke="#A3BF00"
          stroke-width="2.65"
          stroke-miterlimit="10" />
        <path
          d="M323.73 208.702H295.73V237.793H323.73V208.702Z"
          fill="#00233D" />
        <path
          d="M317.078 21.3726H302.448C299.867 21.3726 297.774 23.4654 297.774 26.0471V44.4083C297.774 46.99 299.867 49.0829 302.448 49.0829H317.078C319.659 49.0829 321.752 46.99 321.752 44.4083V26.0471C321.752 23.4654 319.659 21.3726 317.078 21.3726Z"
          fill="#A3BF00" />
        <path
          d="M299.991 28.0474H309.415C310.355 28.0474 311.256 28.4207 311.92 29.0854C312.585 29.75 312.958 30.6514 312.958 31.5913V37.4726C312.958 38.4125 312.585 39.3139 311.92 39.9785C311.256 40.6431 310.355 41.0165 309.415 41.0165H299.991V28.0474Z"
          fill="#7B9D00" />
        <path
          d="M210.233 50.5938L221.472 83.2612"
          stroke="#00233D"
          stroke-width="2.16"
          stroke-miterlimit="10" />
        <path
          d="M202.407 46.7129L180.473 76.3365"
          stroke="#00233D"
          stroke-width="2.16"
          stroke-miterlimit="10" />
        <path
          d="M167.471 92.9631L190.133 122.598C192.627 125.86 197.293 126.482 200.555 123.987L230.185 101.321C233.447 98.8264 234.068 94.1596 231.574 90.8976L208.912 61.2624C206.417 58.0004 201.751 57.3785 198.49 59.8734L168.859 82.5394C165.598 85.0343 164.976 89.7011 167.471 92.9631Z"
          fill="#D6E001" />
        <path
          d="M173.297 92.7626L191.846 117.018C193.885 119.684 197.698 120.192 200.363 118.153L224.615 99.6019C227.28 97.5629 227.788 93.749 225.75 91.0831L207.201 66.8275C205.163 64.1616 201.349 63.6534 198.684 65.6923L174.432 84.2439C171.767 86.2828 171.259 90.0968 173.297 92.7626Z"
          stroke="#00233D"
          stroke-width="1.11"
          stroke-miterlimit="10" />
        <path
          d="M201.484 102.981C200.897 107.33 194.223 106.493 194.81 102.09C195.397 97.6872 202.081 98.5352 201.484 102.981ZM204.353 78.3911L201.734 96.8719L196.125 96.1218C196.951 89.8927 197.647 83.8484 198.473 77.5867L204.353 78.3911Z"
          fill="#00233D" />
        <path
          d="M207.027 53.3443C212.219 53.3443 216.429 49.1342 216.429 43.9408C216.429 38.7474 212.219 34.5374 207.027 34.5374C201.834 34.5374 197.625 38.7474 197.625 43.9408C197.625 49.1342 201.834 53.3443 207.027 53.3443Z"
          fill="#00233D" />
        <path
          d="M213.668 43.9408C213.67 45.2571 213.282 46.5445 212.552 47.64C211.823 48.7355 210.785 49.59 209.569 50.0952C208.354 50.6004 207.016 50.7337 205.725 50.4782C204.434 50.2228 203.248 49.59 202.316 48.66C201.385 47.7299 200.75 46.5445 200.493 45.2536C200.235 43.9628 200.366 42.6245 200.87 41.4082C201.373 40.1918 202.225 39.1521 203.319 38.4206C204.414 37.6891 205.7 37.2986 207.016 37.2986C208.779 37.2986 210.469 37.998 211.716 39.2434C212.963 40.4887 213.665 42.1782 213.668 43.9408V43.9408Z"
          fill="#044F74" />
        <path
          d="M243.896 1.43506V21.3726"
          stroke="#7B9D00"
          stroke-width="2.65"
          stroke-miterlimit="10" />
        <path
          d="M226.016 1.43506V21.3726"
          stroke="#7B9D00"
          stroke-width="2.65"
          stroke-miterlimit="10" />
        <path
          d="M261.699 1.43506V21.3726"
          stroke="#7B9D00"
          stroke-width="2.65"
          stroke-miterlimit="10" />
        <path
          d="M281.492 1.43506V21.3726"
          stroke="#7B9D00"
          stroke-width="2.65"
          stroke-miterlimit="10" />
        <path
          d="M299.959 1.43506V21.3726"
          stroke="#7B9D00"
          stroke-width="2.65"
          stroke-miterlimit="10" />
        <path
          d="M319.1 1.43506V21.3726"
          stroke="#7B9D00"
          stroke-width="2.65"
          stroke-miterlimit="10" />
        <path
          d="M337.903 1.43506V21.3726"
          stroke="#7B9D00"
          stroke-width="2.65"
          stroke-miterlimit="10" />
        <path
          d="M225.092 21.3726L243.896 1.43506"
          stroke="#7B9D00"
          stroke-width="2.65"
          stroke-miterlimit="10" />
        <path
          d="M243.896 21.3726L262.688 1.43506"
          stroke="#7B9D00"
          stroke-width="2.65"
          stroke-miterlimit="10" />
        <path
          d="M262.688 21.3726L281.492 1.43506"
          stroke="#7B9D00"
          stroke-width="2.65"
          stroke-miterlimit="10" />
        <path
          d="M281.492 21.3726L300.296 1.43506"
          stroke="#7B9D00"
          stroke-width="2.65"
          stroke-miterlimit="10" />
        <path
          d="M300.296 21.3726L319.1 1.43506"
          stroke="#7B9D00"
          stroke-width="2.65"
          stroke-miterlimit="10" />
        <path
          d="M319.1 21.3726L337.903 1.43506"
          stroke="#7B9D00"
          stroke-width="2.65"
          stroke-miterlimit="10" />
        <path
          d="M207.026 21.3726H360.315L339.675 1.43506H222.885L207.026 21.3726Z"
          stroke="#A3BF00"
          stroke-width="2.65"
          stroke-linecap="round"
          stroke-linejoin="round" />
        <path
          d="M207.026 21.3726V43.9409"
          stroke="#A3BF00"
          stroke-width="2.65"
          stroke-linecap="round"
          stroke-linejoin="round" />
        <path
          d="M125.975 235.108L136.703 207.365C136.813 207.071 137.01 206.817 137.269 206.638C137.527 206.458 137.834 206.362 138.148 206.362C138.463 206.362 138.769 206.458 139.028 206.638C139.286 206.817 139.484 207.071 139.594 207.365L150.322 235.108H125.975Z"
          fill="#D6E001" />
        <path
          d="M281.957 235.108L292.685 207.365C292.795 207.071 292.993 206.817 293.251 206.638C293.509 206.458 293.816 206.362 294.131 206.362C294.445 206.362 294.752 206.458 295.01 206.638C295.269 206.817 295.466 207.071 295.576 207.365L306.304 235.108H281.957Z"
          fill="#D6E001" />
        <path
          d="M141.789 213H134.5L132.207 219H144.085L141.789 213Z"
          fill="#FAFAFA" />
        <path
          d="M297.771 213H290.482L288.189 219H300.068L297.771 213Z"
          fill="#FAFAFA" />
        <path
          d="M146.216 224.455H130L127.803 230.347H148.5L146.216 224.455Z"
          fill="#FAFAFA" />
        <path
          d="M302.199 224.455H285.983L283.785 230.347H304.482L302.199 224.455Z"
          fill="#FAFAFA" />
        <path
          d="M152.419 235.097H124.018V237.434H152.419V235.097Z"
          fill="#7B9D00" />
        <path
          d="M308.401 235.097H280V237.434H308.401V235.097Z"
          fill="#7B9D00" />
        <path
          d="M89.727 192.011C91.5396 179.837 83.1418 168.499 70.97 166.686C58.7982 164.873 47.4617 173.272 45.6491 185.446C43.8366 197.62 52.2344 208.958 64.4061 210.771C76.5779 212.584 87.9145 204.185 89.727 192.011Z"
          fill="#42B0D5" />
        <path
          d="M67.6934 180.796V237.435"
          stroke="#002039"
          stroke-width="1.14"
          stroke-linecap="round"
          stroke-linejoin="round" />
        <path
          d="M59.0312 181.949L67.694 191.667"
          stroke="#002039"
          stroke-width="1.14"
          stroke-linecap="round"
          stroke-linejoin="round" />
        <path
          d="M75.3779 191.135C74.7584 191.754 67.6934 199.114 67.6934 199.114"
          stroke="#002039"
          stroke-width="1.14"
          stroke-linecap="round"
          stroke-linejoin="round" />
        <path
          d="M0.619141 237.978H374.413"
          stroke="#00786B"
          stroke-width="1.14"
          stroke-linecap="round"
          stroke-linejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="378" height="239" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "@/styles/imports";

#maintenance {
  padding: 24px;
  height: 72vh;
  margin-top: 61px;
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  & > .title {
    color: var(--Gray-900);
    font-size: 32px;
    font-family: "Maersk Text Bold";
    margin: 0;
    padding-bottom: 16px;
  }
  & > .description {
    font-size: 18px;
    font-family: "Maersk Text";
    color: var(--Gray-900);
    margin-bottom: 12px;
    margin: 0;
    padding-bottom: 32px;
  }
  & svg {
    width: 100%;
    height: 239px;
  }
}
</style>
